/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as Check } from 'src/assets/icons/check.svg';
import { ReactComponent as End } from 'src/assets/icons/end.svg';

import { ReactComponent as SaveIcon } from 'src/assets/icons/save.svg';
import { ReactComponent as DeleteIcon } from 'src/assets/icons/delete.svg';
import { ReactComponent as ClearIcon } from 'src/assets/icons/clear.svg';
import { ReactComponent as ArchiveIcon } from 'src/assets/icons/archive.svg';
import { ReactComponent as GoBack } from 'src/assets/icons/goBack.svg';
import { ReactComponent as ShowTodos } from 'src/assets/icons/restore.svg';
import { ReactComponent as Menu } from 'src/assets/icons/menu.svg';
import { ReactComponent as Pdf } from 'src/assets/icons/pdf.svg';

import CustomInput, {
  ConsultaInput,
  SelectInput,
  SelectInput2,
} from '../../customInput';
import { Anexos } from 'src/components/customInput/anexos';
import { RenderPdf } from 'src/components';
import { newTab, newTabRef } from 'src/pages/home';

import SubForm from '../subForm';
import SearchTable from '../searchTable';

import {
  isValid,
  getMsgRet,
  transformResponse,
  tabIndex,
  GetProcesso,
  LogGetProcesso,
  isRetornoSucesso,
} from 'src/services/auth';

import { RenderForm, showToast } from 'src/components';

import { LogContext } from 'src/components/LogProvider';

import { LoadGif } from 'src/components/LoadGif';

import { fileService } from 'src/components/customInput/fileServer';
import { isDark } from 'src/components/DetectBrightness';

import { ReactComponent as TypeNormal } from 'src/assets/icons/typeNormal.svg';
import { ReactComponent as TypeList } from 'src/assets/icons/typeList.svg';

export default function FormularioAdicao({
  onClose,
  children,
  adiData,
  porta,
  tabIndex,
  forceUpdate,
}) {
  const colunas = JSON.parse(adiData.nomeColunas);
  const dados = adiData;

  const { setLogData, setLoadIndex } = useContext(LogContext);
  const idEmp = localStorage.getItem('idEmp');
  const idFil = localStorage.getItem('idFil');
  const showRateio = false; /*adiData.colunas.Dados.rateio === 'S'*/
  const rateioValor = colunas?.Dados?.rateiovalor;
  const [blockList, setBlockList] = useState([]);
  const [corFundo, setCorFundo] = useState('');
  const [showAbaTodos, setShowAbaTodos] = useState(false);

  const abas = colunas?.Dados?.abas?.map((aba) => aba.nome);
  const [chooseAba, setChooseAba] = useState('');
  const [contrastColor, setConstratColor] = useState('');

  const [listType, setListType] = useState('normal');

  const [load, setLoad] = useState(true);

  const [titulo, setTitulo] = useState('');
  const [controls, setControls] = useState([]);

  const [chooseForm, setChooseForm] = useState('');
  const [showWarning, setShowWarning] = useState(false);

  const [showSubform, setShowSubform] = useState('');

  const [subformForm, setSubformForm] = useState({});
  const [subformResults, setSubformResults] = useState({});
  const [extraDataResults, setExtraDataResults] = useState([]);
  const [subformPlain, setSubformPlain] = useState({});

  const [consultaModal, setConsultaModal] = useState(null);
  const [consultaData, setConsultaData] = useState(null);

  const [relatorios, setRelatorios] = useState({});
  const [relatorioModal, setRelatorioModal] = useState(false);
  const [selectRelatorio, setSelectedRelatorio] = useState('');
  const [relatorioModo, setRelatorioModo] = useState('');
  const [relatorioFinal, setRelatorioFinal] = useState({});
  const [selectPdf, setSelectPdf] = useState();
  const [showListaRelatorios, setShowListaRelatorios] = useState();

  const [itemsObrigatorios, setItemsObrigatorios] = useState([]);
  const [formError, setFormError] = useState(false);

  const [consultaTitulo, setConsultaTitulo] = useState('');
  const [activateControls, setActivateControls] = useState(false);

  const [anexos, setAnexos] = useState([]);
  const [arquivo, setArquivo] = useState([]);
  const anexoInput = colunas?.Dados?.anexo;
  const [themeColor, setThemeColor] = useState('#0fa697');

  const [mobileControls, setMobileControls] = useState(false);

  const isAdm =
    localStorage.getItem('IsAdm') === 'S' ||
    localStorage.getItem('IsAdm') === true;

  useEffect(() => {
    //-----MONTAR-FORMULARIO
    setSubformForm(
      Object.keys(colunas?.Dados).reduce((acc, key) => {
        acc[key] = '';
        return acc;
      }, {})
    );

    const rawString = dados?.colblo?.match(/\w+/g) || [];
    const valuesArray = rawString.slice(1);

    setRelatorios(colunas.Dados?.relatorios || {});
    setShowListaRelatorios(isValid(colunas.Dados?.relatorios));

    setBlockList(valuesArray);
    setCorFundo(colunas?.Dados?.corfundo);
    setConstratColor(isDark(colunas?.Dados?.corfundo));
    setChooseAba(isValid(abas) ? abas[0] : '');
  }, []);

  function timedLoad(time) {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
    }, time);
  }

  function HandleOnClose() {
    forceUpdate();
    onClose();
  }

  async function HandleSave() {
    setLoad(true);

    const filteredExtraDataResults = Object.fromEntries(
      Object.entries(extraDataResults).filter(
        ([_, value]) => value.tipAca !== 'R'
      )
    );

    const mergeData = {
      ...subformResults,
      ...filteredExtraDataResults,
      DadosAnexo: arquivo,
    };

    try {
      const response = await GetProcesso(porta, mergeData, true);

      if (isRetornoSucesso(response)) {
        HandleOnClose();
      }
    } catch (error) {
      console.error('Erro ao salvar:', error);
    } finally {
      setLoad(false);
    }
  }

  async function HandleSaveSub(acao, extraData) {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
      setShowSubform(false);
      setChooseForm('');
    }, 500);

    const newData = { ...extraDataResults, ...extraData };

    setExtraDataResults(newData);
  }

  useEffect(() => {
    timedLoad(1000);

    setControls(
      Object.keys(dados ?? {}).filter((key) =>
        key.toLowerCase().includes('coluna')
      )
    );

    setTitulo(
      Object.entries(colunas?.Dados).find(([key]) => key === 'titulo')?.[1] ||
        ''
    );

    getButtons();

    //VALIDA-ITENS-OBRIGATORIOS
    const obrigatorios = Object.entries(colunas?.Dados || {})
      .filter(([_, item]) => item.obrigatorio === 'S')
      .map(([key]) => key);

    setItemsObrigatorios(obrigatorios);
  }, [adiData, chooseAba]);

  const handleClose = () => {
    onClose;
    //setConsultaData(null);
  };
  const handleSetSearch = (data) => {
    setConsultaModal(false);
    setConsultaData(null);

    setSubformForm((prev) => ({
      ...prev,
      ...data,
    }));
  };

  useEffect(() => {
    getButtons();
  }, [subformForm]);

  useEffect(() => {
    const subformTags = controls.map((item) => item.replace(/Colunas$/i, ''));
    const subformTagsObj = subformTags.reduce((acc, key) => {
      acc[key] = {};
      return acc;
    }, {});

    const newResults = {
      ...subformForm,
      ...subformTagsObj,
      tipAca: 'I',
    };

    const isEqual =
      JSON.stringify(subformResults) === JSON.stringify(newResults);
    if (!isEqual) {
      setSubformResults(newResults);
    }
  }, [subformForm, chooseAba]);

  const formatData = (data) => {
    const [dataAno, dataMes, dataDia] = data.split('-');
    return `${dataDia}/${dataMes}/${dataAno}`;
  };

  function handleConsultaRelatorio(data) {
    setLoad(true);

    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => isValid(value))
    );

    const thisData = {
      arqJso: JSON.stringify({
        ...filteredData,
        codemp: idEmp,
        codfil: idFil,
        tipAca: 'ADI',
      }),
    };

    GetProcesso(selectRelatorio.porta, thisData, true, true)
      .then((res) => {
        const relatorio = JSON.parse(res.arqJso);

        if (typeof relatorio === 'object') setRelatorioFinal(relatorio);
        else {
          setRelatorioFinal({});
        }
      })
      .catch((error) => {
        showToast('error', error);
        setRelatorioModo('');
      })
      .finally(() => {
        setLoad(false);
      });
  }

  const [buttons, setButtons] = useState([]);
  function getButtons() {
    const newButtons = Object.entries(colunas?.Dados).map(
      ([key, item], index) => {
        let tipo = 'text';
        switch (item.tipo) {
          case 'string':
            tipo = 'text';
            break;
          case 'integer':
            tipo = 'number';
            break;
          case 'float':
            tipo = 'number';
            break;
          case 'date':
            tipo = 'date';
            break;
          case 'webservice':
            tipo = 'consulta';
            break;
          case 'webserviceexterno':
            tipo = 'consulta';
            break;
          case 'webservicemodulo':
            tipo = 'consulta';
            break;
          case 'select':
            tipo = 'select';
            break;
          case 'select2':
            tipo = 'select2';
            break;
          default:
            tipo = 'text';
            break;
        }

        const excludeKeys = [
          'abas',
          'titulo',
          'endpoint',
          'relatorios',
          'acoes',
          'repete',
          'downloadupload',
          'gridsalvar',
          'griddeletar',
          'rateio',
          'rateiovalor',
          'corfundo',
          'anexo',
        ];

        if (isValid(item?.corborda)) setThemeColor(item?.corborda);

        const thisBlock = blockList.includes(key);

        const thisTabIndex = Number(item?.posicao) + 900;

        if (abas?.length < 1 || chooseAba === '' || item.id === chooseAba) {
          let valor = subformForm[key] !== undefined ? subformForm[key] : '';

          if (tipo === 'date' && valor) {
            const [day, month, year] = valor.split('/');
            valor = `${year}-${month}-${day}`;
          }

          if (!excludeKeys.includes(key) && item?.mostrar != 'N') {
            const defaultInput =
              tipo !== 'consulta' && tipo !== 'select' && tipo !== 'select2';
            return (
              <div
                key={index}
                style={{ order: `${item.posicao}` }}
                className={`tamanho${item.tamanho}`}
              >
                {defaultInput && (
                  <CustomInput
                    Class={
                      item.obrigatorio === 'S' && !isValid(subformForm[key])
                        ? 'obr'
                        : ''
                    }
                    PlaceHolder={`${item.nome} ${item.obrigatorio === 'S' ? '*' : ''} ${thisBlock ? '🔒' : ''}`}
                    Key={isAdm ? key : null}
                    Type={tipo}
                    OnChange={(e) => {
                      if (tipo === 'date') {
                        setSubformForm((prev) => ({
                          ...prev,
                          [key]: formatData(e.target.value),
                        }));
                      } else {
                        setSubformForm((prev) => ({
                          ...prev,
                          [key]: e.target.value,
                        }));
                      }
                    }}
                    Disabled={item.editavel === 'N' || thisBlock}
                    CorFundo={item.corfundo}
                    CorTexto={item.cortexto}
                    Color={item.corborda}
                    DefaultValue={valor}
                    TabIndex={item.editavel !== 'N' ? thisTabIndex : 999} //--------------
                  />
                )}
                {tipo === 'consulta' && (
                  <ConsultaInput
                    Class={
                      item.obrigatorio === 'S' && !isValid(subformForm[key])
                        ? 'obr'
                        : ''
                    }
                    PlaceHolder={`${item.nome} ${item.obrigatorio === 'S' ? '*' : ''} ${thisBlock ? '🔒' : ''}`}
                    Key={isAdm ? key : null}
                    Type={tipo}
                    OnChange={(e) =>
                      setSubformForm((prev) => ({
                        ...prev,
                        [key]: e.target.value,
                      }))
                    }
                    Disabled={item.editavel === 'N' || thisBlock}
                    CorFundo={item.corfundo}
                    CorTexto={item.cortexto}
                    Color={item.corborda}
                    OnPress={() => {
                      setConsultaModal(true);
                      setConsultaData(item);
                      setConsultaTitulo(item.nome);
                    }}
                    DefaultValue={valor}
                    TabIndex={item.editavel !== 'N' ? thisTabIndex : 999} //--------------
                  />
                )}
                {tipo === 'select' && (
                  <SelectInput
                    Class={
                      item.obrigatorio === 'S' && !isValid(subformForm[key])
                        ? 'obr'
                        : ''
                    }
                    PlaceHolder={`${item.nome} ${item.obrigatorio === 'S' ? '*' : ''} ${thisBlock ? '🔒' : ''}`}
                    Key={isAdm ? key : null}
                    Type={tipo}
                    OnChange={(e) =>
                      setSubformForm((prev) => ({
                        ...prev,
                        [key]: e.target.value,
                      }))
                    }
                    Disabled={item.editavel === 'N' || thisBlock}
                    Options={item.options}
                    CorFundo={item.corfundo}
                    CorTexto={item.cortexto}
                    Color={item.corborda}
                    DefaultValue={valor}
                    TabIndex={item.editavel !== 'N' ? thisTabIndex : 999} //--------------
                  />
                )}
                {tipo === 'select2' && (
                  <SelectInput2
                    Class={
                      item.obrigatorio === 'S' && !isValid(subformForm[key])
                        ? 'obr'
                        : ''
                    }
                    PlaceHolder={`${item.nome} ${item.obrigatorio === 'S' ? '*' : ''} ${thisBlock ? '🔒' : ''}`}
                    Key={isAdm ? key : null}
                    Type={'select'}
                    OnChange={(e) => {
                      setSubformForm((prev) => ({
                        ...prev,
                        [key]: e.target.value,
                      }));
                    }}
                    Disabled={item.editavel === 'N' || thisBlock}
                    Options={item.options}
                    Filtro={item.origemFiltro.map((item, index) => {
                      return subformForm[item];
                    })}
                    CorFundo={item.corfundo}
                    CorTexto={item.cortexto}
                    Color={item.corborda}
                    DefaultValue={valor}
                    TabIndex={item.editavel !== 'N' ? thisTabIndex : 999} //--------------
                  />
                )}
              </div>
            );
          }
        }
        return null;
      }
    );

    setButtons(newButtons);
  }

  useEffect(() => {
    const checkItemsObrigatorios = itemsObrigatorios.every((key) => {
      return subformResults[key] !== '';
    });

    setActivateControls(checkItemsObrigatorios);
  }, [subformResults]);

  useEffect(() => {
    setLoadIndex((prev) => ({
      ...prev,
      [tabIndex]: load,
    }));
  }, [load]);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  async function handleAddFile(file) {
    if (!file) return;

    const arquivoConvertido = {
      nomearq: file.name,
      basarq: await toBase64(file),
    };

    setAnexos((prev) => [...prev, file]);
    setArquivo((prev) => [...(prev || []), arquivoConvertido]);
  }
  function handleExcludeFile(fileToRemove) {
    setAnexos((prev) => prev?.filter((file) => file !== fileToRemove));

    setArquivo((prev) =>
      prev?.filter((item) => item.nomarq !== fileToRemove.name)
    );
  }

  return (
    <div
      className={`popup absoluteCenter mobileFullscreen ${formError ? 'erro' : ''}`}
    >
      <div className={`wrap ${listType}`} style={{ backgroundColor: corFundo }}>
        {relatorioModal && (
          <>
            <button
              className="subFormFade"
              onClick={() => setRelatorioModal(false) /*handleClose*/}
            />

            <div
              className={`modal absoluteCenter relatoriosModal ${relatorioModo}`}
            >
              {load && <div className="subFormFade" />}

              <span className="header">
                <span className="title">
                  <h2>
                    Relatórios <hr />
                  </h2>
                </span>
                {relatorioModo === 'resultado' && (
                  <button
                    className="mainButton turquoise"
                    onClick={() => {
                      setRelatorioModo('consulta');
                    }}
                  >
                    Retornar
                  </button>
                )}
              </span>

              {relatorioModo === '' && (
                <div>
                  {Object.entries(relatorios || {})?.map(([key, item]) => {
                    return (
                      <button
                        key={key}
                        className="mainButton turquoise"
                        onClick={() => {
                          setSelectedRelatorio(item);
                          setRelatorioModo('consulta');
                        }}
                      >
                        {item.nome}
                      </button>
                    );
                  })}

                  <span className="submitRow">
                    <button
                      className="mainButton turquoise"
                      onClick={() => setRelatorioModal(false)}
                    >
                      retornar
                    </button>
                  </span>
                </div>
              )}

              {relatorioModo === 'consulta' && (
                <RenderForm
                  data={selectRelatorio}
                  onSubmit={() => handleConsultaRelatorio(subformForm)}
                />
              )}

              {relatorioModo === 'lista' && !load && (
                <div className="relatorioLista">
                  {(relatorioFinal?.Dados || [])?.map((item, index) => (
                    <button
                      className="relatorioItem"
                      key={index}
                      onClick={() => {
                        newTab(item.nome, <RenderPdf data={item.base64} />);
                      }}
                    >
                      <Pdf />
                      <span>
                        {item.nome}
                        <hr />
                      </span>
                    </button>
                  ))}

                  <span className="submitRow">
                    <button
                      className="mainButton turquoise"
                      onClick={() => setRelatorioModo('')}
                    >
                      retornar
                    </button>
                  </span>
                </div>
              )}

              {/*relatorioModo === 'resultado' && <RenderPdf data={selectPdf} />*/}
            </div>
          </>
        )}

        {abas?.length > 0 && (
          <div className={`formTabs ${contrastColor}`}>
            {showAbaTodos && (
              <button
                className={`formTabItem ${chooseAba === '' ? 'active' : 'notActive'}`}
                style={{
                  backgroundColor: isValid(corFundo) ? corFundo : 'inherit',
                  color: contrastColor,
                }}
                onClick={() => setChooseAba('')}
              >
                Todos
              </button>
            )}

            {abas.map((item, index) => (
              <button
                key={index}
                className={`formTabItem ${chooseAba === item ? 'active' : 'notActive'}`}
                style={{
                  backgroundColor: isValid(corFundo) ? corFundo : 'inherit',
                  color: contrastColor,
                }}
                onClick={() => setChooseAba(item)}
              >
                {item}
              </button>
            ))}
          </div>
        )}

        {showWarning && (
          <div className="warning absoluteCenter mainShadow">
            <p> Fechar </p> <span>formulário</span>
            <div>
              <button
                onClick={() => {
                  setShowSubform('');
                  setShowWarning(false);
                  setChooseForm('');
                }}
              >
                Sim
              </button>
              <button onClick={() => setShowWarning(false)}> Não </button>
            </div>
          </div>
        )}
        {showSubform && (
          <SubForm
            id={chooseForm}
            onClose={() => {
              setShowSubform(false);
              setChooseForm('');
            }}
            Class={showWarning ? 'fadeContent' : ''}
            allData={adiData}
            myExtraData={extraDataResults}
            saveFunction={HandleSaveSub}
            modo={'add'}
            tabIndex={tabIndex}
            blockAdd={blockList.includes('Adicionar')}
            formData={subformForm}
          />
        )}
        {/*<div className={`loading ${load ? 'show' : 'hide'}`}>
                        <img src={Load} />
                      </div>*/}
        {load && <LoadGif />}
        {load && (
          <div
            className="blockFade"
            style={{ backgroundColor: `${corFundo}` }}
          />
        )}
        <span className="title">
          <h2 style={{ color: contrastColor }}>
            Adicionar {titulo}
            <hr
              style={{
                backgroundColor: themeColor,
                borderBlockColor: themeColor,
              }}
            />
          </h2>

          <div className={`listType ${contrastColor}`}>
            {isValid(abas) && (
              <button
                className={showAbaTodos && 'active'}
                onClick={() => {
                  if (!showAbaTodos) {
                    setShowAbaTodos(true);
                    setChooseAba('');
                  } else {
                    if (chooseAba === '')
                      setChooseAba(isValid(abas) && abas[0]);
                    setShowAbaTodos(false);
                  }
                }}
              >
                <label> Mostrar: Todos </label>
                <ShowTodos />
              </button>
            )}
            <button
              className={listType === 'normal' && 'active'}
              onClick={() => setListType('normal')}
            >
              <label> Layout: Padrão </label>
              <TypeNormal />
            </button>
            <button
              className={listType === 'list' && 'active'}
              onClick={() => setListType('list')}
            >
              <label> Layout: Lista </label>
              <TypeList />
            </button>
          </div>
        </span>
        <div className="content scroll">
          <div className="column">
            <div className={listType}>
              {consultaModal && (
                <>
                  <button
                    className="subFormFade"
                    onClick={() => setConsultaModal(false) /*handleClose*/}
                  />

                  <div className="modal absoluteCenter consultaModal">
                    <SearchTable
                      webservice={consultaData}
                      SetSearch={handleSetSearch}
                      Titulo={consultaTitulo}
                      onClose={() => setConsultaModal(false)}
                      defaultData={subformForm}
                      tabIndex={tabIndex}
                      url={consultaData.endpoint.url}
                      extraData={subformForm}
                      extraExtraData={subformForm}
                    />
                  </div>
                </>
              )}

              {buttons}

              {anexoInput?.mostrar === 'S' && anexoInput.id === chooseAba && (
                <Anexos
                  Editavel={anexoInput?.editavel === 'S'}
                  Config={anexoInput}
                  OnChange={handleAddFile}
                  Anexos={anexos}
                  RemoveAnexo={handleExcludeFile}
                />
              )}
            </div>

            {formError && (
              <h5 style={{ order: '1000' }}>
                Verifique se todos os items obrigatórios foram preenchidos
              </h5>
            )}
          </div>
        </div>
      </div>
      <div
        className={`controls ${!activateControls ? 'disabled' : ''} ${mobileControls ? 'mobileControls' : ''} ${showSubform ? 'deactive' : ''}`}
        style={{ backgroundColor: corFundo }}
      >
        <span className={`mobileHandler ${contrastColor}`}>
          <button
            className={mobileControls ? 'active' : ''}
            onClick={() => setMobileControls(!mobileControls)}
            style={{
              backgroundColor: isValid(corFundo) ? corFundo : 'inherit',
            }}
          >
            <Menu />
          </button>
        </span>

        <button
          className="icon cancelar"
          onClick={() => onClose()}
          disabled={load}
        >
          Cancelar <GoBack />
        </button>

        <button
          className="icon salvar"
          onClick={() => {
            const checkItemsObrigatorios = itemsObrigatorios.every((key) => {
              return isValid(subformResults[key]);
            });

            // eslint-disable-next-line no-constant-condition
            if (!checkItemsObrigatorios) {
              setFormError(true);
            } else {
              HandleSave();
            }
          }}
          disabled={blockList.includes('Salvar') || load}
        >
          {`Salvar ${blockList.includes('Salvar') ? '🔒' : ''}`} <ArchiveIcon />
        </button>

        {showRateio && (
          <div className="controle">
            <span />
            <button>Rateio</button>
          </div>
        )}

        {showListaRelatorios && (
          <div className={`controle`}>
            <span />
            <button
              onClick={() => {
                setRelatorioModo('');
                setRelatorioModal(true);
              }}
            >
              Relatórios
            </button>
          </div>
        )}

        {controls.map((item, index) => {
          const titulo = dados[item]
            ? JSON.parse(dados[item]).Dados.titulo
            : '';

          if (item != 'nomeColunas')
            return (
              <div key={index} className="controle">
                <span />
                <button
                  className={chooseForm === item ? 'active' : ''}
                  onClick={() => {
                    setMobileControls(false);
                    if (chooseForm !== item) {
                      setChooseForm('');
                      setShowSubform(false);

                      setTimeout(() => {
                        setChooseForm(item);
                        setShowSubform(true);
                      }, 10);
                    } else {
                      setChooseForm('');
                      setShowSubform(false);
                    }
                  }}
                >
                  {titulo}
                </button>
              </div>
            );
        })}
      </div>
    </div>
  );
}

FormularioAdicao.propTypes = {
  onClose: PropTypes.func.isRequired,
  forceUpdate: PropTypes.func,
  children: PropTypes.node,
  controls: PropTypes.array,
  adiData: PropTypes.object,
  porta: PropTypes.string,
  tabIndex: PropTypes.number,
};
